import { Context } from '#store/overmind';
import { ContentType } from '#types/generated/graphql-types';

export const initPlayer = (
  { state }: Context,
  payload: { iri: string; contentType?: ContentType }
) => {
  state.player.contentType = payload.contentType || null;
  state.player.mediaIri = payload.iri;
  state.player.visible = true;
};

export const disposePlayer = ({ state }: Context) => {
  state.player.visible = false;
  state.player.contentType = null;
  state.player.mediaIri = null;
};

export const hidePlayer = ({ state }: Context) => {
  state.player.visible = false;
};

export const showPlayer = ({ state }: Context) => {
  state.player.visible = true;
};
